import restfulBase from '@/services/negotiations/core/base';

export const contactService = (companyId: string) => restfulBase(`companies/${companyId}/contacts`);

export default contactService;
